/**
 * FAQ accordion (full-width block).
 */
export default function initFaqAccordion() {
    $('.faq').each(function initFaqBlock() {
        const $faq = $(this);

        $faq.find('.faq__trigger').on('click', function onFaqTriggerClick() {
            const $trigger = $(this);
            const $item = $trigger.closest('.faq__item');
            const $panel = $item.find('.faq__panel');
            const isOpen = $item.hasClass('is-open');

            if (isOpen) {
                $item.removeClass('is-open');
                $trigger.attr('aria-expanded', 'false');
                $panel.stop(true, true).slideUp(280, () => {
                    $panel.attr('hidden', true);
                });
            } else {
                $item.addClass('is-open');
                $trigger.attr('aria-expanded', 'true');
                $panel.removeAttr('hidden').hide().stop(true, true).slideDown(280);
            }
        });
    });
}
